import { useEffect, useState, useRef } from 'react';
import { Button, message, Modal, Space, Layout } from 'antd';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move';
import AddQuestionBankModal from './components/AddQuestionBankModal';
import AddQuestionModal from './components/AddQuestionModal';
import { getQuestionBankListApi, addQuestionBankApi, delQuestionBankApi, updateQuestionBankApi, addQuestionApi, patchQuestionApi, patchQuestionBankApi, delQuestionApi, updateQuestionApi } from '@services/Wj';
import PageHeader from '@components/PageHeader/PageHeader';
import './index.less';

export default function Questionbank() {
    useEffect(() => {
        document.title = '题库配置-医调研';
    }, []);

    const [data, setData] = useState([]);
    // 题库类型
    const [isModalOpen, setIsModalopen] = useState(false);
    const [title, setTitle] = useState('添加');
    // 题目
    const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
    const [questionTitle, setQuestionTitle] = useState('添加题目');

    // 当前编辑的题型类
    const [curQesBank, setCurQesbank] = useState(undefined);
    // 当前编辑的题目
    const [curQes, setCurQes] = useState(undefined);

    const questionRef = useRef(null);
    // 添加题库类型
    const onModalOk = async (res, callback) => {
        let result, params;
        if (title === '添加') {
            params = {
                name: res.name,
            };
            result = await addQuestionBankApi(params);
        } else {
            params = {
                id: curQesBank.id,
                name: res.name,
            };
            result = await updateQuestionBankApi(params);
        }
        if (result.status_code === 200) {
            message.success(`${title}成功`);
            getQuestionBankListData();
            setIsModalopen(false);
            callback();
        }
    };

    const onQuestionModalOk = async (pa, callback) => {
        let result;
        console.log(curQesBank);
        if (questionTitle === '添加题目') {
            pa.questionCateId = curQesBank.id;
            result = await addQuestionApi(pa);
        } else {
            pa = {
                ...curQes,
                ...pa,
            };
            result = await updateQuestionApi(pa);
        }

        if (result.status_code === 200) {
            message.success(`${questionTitle}成功`);
            getQuestionBankListData();
            setIsQuestionModalOpen(false);
            questionRef.current.clearBody?.();
            callback();
        }
    };

    const handdleClose = () => {
        setIsQuestionModalOpen(false);
    };

    // 题库类型编辑
    const onBankEditClick = item => {
        setCurQesbank(item);
        setTitle('编辑');
        setIsModalopen(true);
    };
    const onAddBankClick = () => {
        setTitle('添加');
        setIsModalopen(true);
    };
    const onBankDeleteClick = item => {
        Modal.confirm({
            title: '提示',
            content: '是否确认删除',
            cancelText: '取消',
            okText: '确认',
            closable: true,
            onOk: async () => {
                const params = {
                    id: item.id,
                };
                const res = await delQuestionBankApi(params);
                if (res.status_code === 200) {
                    message.success('删除成功');
                    getQuestionBankListData();
                }
            },
        });
    };

    // 题目编辑以及添加
    const onQuestionAdd = item => {
        setCurQesbank(item);
        setCurQes(undefined);
        setQuestionTitle('添加题目');
        setIsQuestionModalOpen(true);
    };
    const onQuestionEdit = item => {
        setCurQes(item);
        setQuestionTitle('编辑题目');
        setIsQuestionModalOpen(true);
    };
    const onDeleteClick = item => {
        Modal.confirm({
            title: '提示',
            content: '是否确认删除',
            cancelText: '取消',
            okText: '确认',
            closable: true,
            onOk: async () => {
                const params = {
                    id: item.id,
                };
                const res = await delQuestionApi(params);
                if (res.status_code === 200) {
                    message.success('删除成功');
                    getQuestionBankListData();
                }
            },
        });
    };

    const onSortEndChildHandler = ({ oldIndex, newIndex }, a) => {
        const newData = data,
            ind = data.findIndex(it => it.id === a);
        const items = data[ind].questionList;
        newData[ind].questionList = arrayMoveImmutable(items, oldIndex, newIndex);
        setData(newData.slice());

        patchQuestionApi({ ids: newData[ind].questionList.map(item => item.id) });
    };

    // const Sortable
    const SortableChildElement = SortableElement(({ childData, paSort }) => (
        <div className="item_wrap child_item_wrap">
            <span>{childData.name || childData.title}</span>
            {paSort !== 0 ? (
                <Space>
                    <SortableMainHandle></SortableMainHandle>
                    <Button type="link" disabled={childData.questionTypeId === 7} onClick={() => onQuestionEdit(childData)}>
                        编辑
                    </Button>
                    <Button type="link" danger disabled={childData.questionTypeId === 7} onClick={() => onDeleteClick(childData)}>
                        删除
                    </Button>
                </Space>
            ) : null}
        </div>
    ));

    const SortableChildContainer = SortableContainer(({ childItems, paSort }) => {
        return <div className="child_container_wrap">{childItems?.length ? childItems.map((item, index) => <SortableChildElement childData={item} paSort={paSort} index={index} key={index}></SortableChildElement>) : null}</div>;
    });

    const SortableMainHandle = SortableHandle(() => {
        return (
            <Button type="link">
                <span className="dragicon">&#xe636;</span>
                &nbsp;&nbsp;拖动
            </Button>
        );
    });

    const SortableMainElement = SortableElement(({ itemData, sort }) => {
        const hasAdress = itemData?.questionList?.some(it => it.questionTypeId === 7) || false;
        return (
            <div className="main_item_wrap">
                <div className="item_wrap">
                    <span>{itemData.name}</span>
                    {sort !== 0 ? (
                        <Space>
                            <Button type="link" onClick={() => onQuestionAdd(itemData)}>
                                添加题目
                            </Button>
                            <SortableMainHandle></SortableMainHandle>
                            <Button type="link" onClick={() => onBankEditClick(itemData)}>
                                编辑
                            </Button>
                            <Button type="link" danger disabled={hasAdress} onClick={() => onBankDeleteClick(itemData)}>
                                删除
                            </Button>
                        </Space>
                    ) : null}
                </div>

                <SortableChildContainer useDragHandle paSort={sort} childItems={itemData.typeList || itemData.questionList} distance={10} onSortEnd={res => onSortEndChildHandler(res, itemData.id)} />
            </div>
        );
    });

    const SortableMainContainer = SortableContainer(({ items }) => {
        return <div className="main_content_wrap">{items.length ? items.map((item, index) => <SortableMainElement itemData={item} index={index} key={index} sort={index} />) : null}</div>;
    });

    const onSortEndHandler = ({ oldIndex, newIndex }) => {
        if (newIndex === 0) {
            message.info('基础题型位置不能修改');
            return;
        }
        const res = arrayMoveImmutable(data, oldIndex, newIndex);
        setData(res);

        patchQuestionBankApi({ ids: res.map(item => item.id) });
    };

    const getQuestionBankListData = async () => {
        const params = {};
        const bankData = await getQuestionBankListApi(params);

        if (bankData.status_code === 200) {
            setData(bankData.data);
        }
    };

    useEffect(() => {
        getQuestionBankListData();
    }, []);

    return (
        <>
            <PageHeader title="题库配置" breadcrumb={[{ label: '医调研' }, { label: '基础配置' }, '题库配置']} />

            <div className="page-route-body questionbank_wrap">
                <Space orientation="vertical" size="medium" className="questionbank_wrap_content">
                    <Button type="primary" onClick={() => onAddBankClick()}>
                        添加题库分类
                    </Button>

                    <SortableMainContainer useWindowAsScrollContainer={true} useDragHandle distance={10} items={data} onSortEnd={onSortEndHandler} helperClass="testClass" />
                </Space>

                <AddQuestionBankModal defaultValue={curQesBank?.name || ''} title={title} isModalVisiable={isModalOpen} onClose={() => setIsModalopen(false)} onOk={onModalOk} />

                <AddQuestionModal title={questionTitle} defaultValue={curQes} isModalVisiable={isQuestionModalOpen} onClose={() => handdleClose()} onOk={onQuestionModalOk} ref={questionRef} />
            </div>
        </>
    );
}
